import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { StyledCard } from '../Card/styles';

export const StyledParagraph = styled.p`
  font-size: ${themeGet('scale.scaleUp02')};
  text-align: ${(props) => props.align};

  ${StyledCard} & {
    font-size: ${themeGet('scale.scaleUp01')};
  }
`;

export default StyledParagraph;
